export default [
  {
    ID: 1,
    site_publisher_ID: 1,
    title: "صفحه اصلی",
    pattern: "/",
    link: "https://batmatic-test.ir",
    state: "تایید شده",
    active: true,
    created_at: "۱۰:۲۱:۴۴ ۱۴۰۱/۰۴/۲۴",
    image: "main-page.webp",
    positions: [
      {
        ID: 1,
        pageID: 1,
        size: "300-600",
        count: 3,
        base_price: 6000,
        price: 2000,
        hilite_commission: 0,
        publisher_right: 0,
        allow_alternative: true,
        score_alternative: 2000,
        state: "در حال انتظار",
        active: true,
        created_at: "۱۲:۲۱:۴۴ ۱۴۰۱/۰۴/۲۵",
      },
      {
        ID: 2,
        pageID: 1,
        size: "970-90",
        count: 2,
        base_price: 6000,
        price: 3000,
        hilite_commission: 0,
        publisher_right: 0,
        allow_alternative: true,
        score_alternative: 2500,
        state: "رد شده از طرف اپراتور",
        active: true,
        created_at: "۲۰:۲۱:۴۴ ۱۴۰۱/۰۴/۲۶",
        message: "قیمت پایه شما بسیار بالا است.",
      },
      {
        ID: 3,
        pageID: 1,
        size: "300-250",
        count: 1,
        base_price: 7000,
        price: 7000,
        hilite_commission: 0,
        publisher_right: 0,
        allow_alternative: false,
        state: "تایید موقت و ارسال پیشنهاد به نمایش دهنده",
        active: true,
        created_at: "۱۶:۲۱:۴۴ ۱۴۰۱/۰۴/۲۷",
        suggestion: "با سلام.حق نمایش دهنده ۶۰۰۰ و کمسیسون هایلایت ۱۰۰۰ است.",
      },
      {
        ID: 4,
        pageID: 1,
        size: "300-600",
        count: 2,
        base_price: 12000,
        price: 6000,
        hilite_commission: 1000,
        publisher_right: 5000,
        allow_alternative: true,
        score_alternative: 5000,
        state: "تایید نهایی",
        active: true,
        tag_html_id: "hilite-position-1891",
        created_at: "۰۸:۲۱:۴۴ ۱۴۰۱/۰۴/۲۸",
      },
    ],
  },
  {
    ID: 2,
    site_publisher_ID: 1,
    title: "صفحه تماس با ما",
    pattern: "/contact-us",
    link: "https://batmatic-test.ir/contact-us",
    state: "تایید شده",
    active: true,
    created_at: "۱۰:۲۱:۴۴ ۱۴۰۱/۰۴/۲۵",
    image: "contact-us-page.webp",
    positions: [
      {
        ID: 5,
        pageID: 2,
        size: "970-250",
        count: 2,
        base_price: 4000,
        price: 2000,
        hilite_commission: 0,
        publisher_right: 0,
        allow_alternative: true,
        score_alternative: 2000,
        state: "در حال انتظار",
        active: true,
        created_at: "۱۲:۲۱:۴۴ ۱۴۰۱/۰۴/۲۶",
      },
      {
        ID: 6,
        pageID: 2,
        size: "720-300",
        count: 4,
        base_price: 8000,
        price: 2000,
        hilite_commission: 0,
        publisher_right: 0,
        allow_alternative: true,
        score_alternative: 2500,
        state: "رد شده از طرف اپراتور",
        active: true,
        created_at: "۲۰:۲۱:۴۴ ۱۴۰۱/۰۴/۲۶",
        message: "تعداد بنر در جایگاه زیاد است.",
      },
      {
        ID: 7,
        pageID: 2,
        size: "180-600",
        count: 2,
        base_price: 10000,
        price: 5000,
        hilite_commission: 0,
        publisher_right: 0,
        allow_alternative: false,
        state: "رد شدن پیشنهاد از طرف نمایش دهنده",
        active: true,
        created_at: "۱۶:۲۱:۴۴ ۱۴۰۱/۰۴/۲۷",
        suggestion: "با سلام.حق نمایش دهنده ۳۰۰۰ و کمسیسون هایلایت ۲۰۰۰ است.",
        message: "مبلغ درخواستی شما بسیار پایین است.",
      },
    ],
  },
  {
    ID: 3,
    site_publisher_ID: 1,
    title: "صفحه درباره ما",
    pattern: "/about-us",
    link: "https://batmatic-test.ir/about-us",
    state: "در حال انتظار",
    active: true,
    created_at: "۱۰:۲۱:۴۴ ۱۴۰۱/۰۴/۲۶",
    image: "about-us-page.webp",
    positions: [],
  },
  {
    ID: 4,
    site_publisher_ID: 1,
    title: "صفحات مطالب",
    pattern: "/@s",
    link: "https://batmatic-test.ir/انواع-کابینت",
    state: "تایید شده",
    active: false,
    created_at: "۱۰:۲۱:۴۴ ۱۴۰۱/۰۴/۲۷",
    image: "page-1.webp",
    positions: [
      {
        ID: 8,
        pageID: 4,
        size: "180-600",
        count: 1,
        base_price: 6000,
        price: 6000,
        hilite_commission: 0,
        publisher_right: 0,
        allow_alternative: true,
        score_alternative: 5000,
        state: "تایید شدن پیشنهاد از طرف نمایش دهنده",
        active: true,
        created_at: "۱۲:۲۱:۴۴ ۱۴۰۱/۰۴/۲۶",
      },
      {
        ID: 9,
        pageID: 4,
        size: "720-300",
        count: 4,
        base_price: 8000,
        price: 2000,
        hilite_commission: 0,
        publisher_right: 0,
        allow_alternative: true,
        score_alternative: 2000,
        state: "تایید موقت و ارسال پیشنهاد به نمایش دهنده",
        active: true,
        created_at: "۲۰:۲۱:۴۴ ۱۴۰۱/۰۴/۲۶",
        suggestion: "با سلام.حق نمایش دهنده ۱۷۰۰ و کمسیسون هایلایت ۳۰۰ است.",
      },
      {
        ID: 10,
        pageID: 4,
        size: "970-90",
        count: 2,
        base_price: 10000,
        price: 5000,
        hilite_commission: 0,
        publisher_right: 0,
        allow_alternative: false,
        state: "تایید نهایی",
        active: true,
        created_at: "۱۶:۲۱:۴۴ ۱۴۰۱/۰۴/۲۷",
        tag_html_id: "hilite-position-1890",
      },
    ],
  },
  {
    ID: 5,
    site_publisher_ID: 1,
    title: "صفحات محصولات",
    pattern: "/product/@s",
    link: "https://batmatic-test.ir/product/دستگیره-کابینت-مدل-a",
    state: "رد شده",
    active: true,
    created_at: "۱۰:۲۱:۴۴ ۱۴۰۱/۰۴/۳۰",
    image: "page-2.webp",
    message: "صفحاتی با چنین مشخصاتی در سایت شما موجود نیست.",
    positions: [],
  },
];
